import React from 'react';
import { ColumnDef, SortingState } from '@tanstack/react-table';
import TextField from '@mui/material/TextField';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import BaseTanStackTable from '../../../components/BaseTanStackTable';
import { useModal } from '../../../hooks/useModal';
import DetailModalAtivos from '../modals/DetailModalAtivos';
import EditModalAtivos from '../modals/EditModalAtivos';
import EditRegraModalAtivos from '../modals/EditRegraModalAtivos';
import EditRegraModalOutrosAtivos from '../modals/EditRegraModalOutrosAtivos';

interface TableAtivosProps {
  columns: ColumnDef<any>[];
  data: any[];
  pageCount: number;
  pagination: { pageIndex: number; pageSize: number };
  setPagination: React.Dispatch<React.SetStateAction<{ pageIndex: number; pageSize: number }>>;
  sorting: SortingState;
  setSorting: React.Dispatch<React.SetStateAction<SortingState>>;
  isLoading: boolean;
  globalFilter: string;
  setGlobalFilter: (value: string) => void;
  segmentoNome?: string;
}

const TableAtivos: React.FC<TableAtivosProps> = ({
  columns,
  data,
  pageCount,
  pagination,
  setPagination,
  sorting,
  setSorting,
  isLoading,
  globalFilter,
  setGlobalFilter,
  segmentoNome,
}) => {
  const detailModal    = useModal<any>();
  const editModal      = useModal<any>();
  const editRegraModal = useModal<any>();

  return (
    <>
      <BaseTanStackTable
        columns={columns}
        data={data}
        pageCount={pageCount}
        pagination={pagination}
        setPagination={setPagination}
        sorting={sorting}
        setSorting={setSorting}
        globalFilter={globalFilter}
        setGlobalFilter={setGlobalFilter}
        isLoading={isLoading}
        toolbar={
          <TextField
            value={globalFilter}
            onChange={(e) => setGlobalFilter(e.target.value)}
            placeholder="Buscar na tabela..."
            variant="outlined"
            size="small"
            style={{ width: '300px' }}
          />
        }
        renderActions={(row) => (
          <>
            <VisibilityIcon
              onClick={() => detailModal.open(row)}
              style={{ cursor: 'pointer', marginRight: '10px' }}
            />
            <EditIcon
              onClick={() => editModal.open(row)}
              style={{ cursor: 'pointer', marginRight: '10px' }}
            />
            <PriceChangeIcon
              onClick={() => editRegraModal.open(row)}
              style={{ cursor: 'pointer' }}
            />
          </>
        )}
      />

      {detailModal.isOpen && detailModal.item && (
        <DetailModalAtivos
          isOpen={detailModal.isOpen}
          onRequestClose={detailModal.close}
          rowData={detailModal.item}
          segmentoNome={segmentoNome}
        />
      )}
      {editModal.isOpen && editModal.item && (
        <EditModalAtivos
          isOpen={editModal.isOpen}
          onRequestClose={editModal.close}
          rowData={editModal.item}
          segmentoNome={segmentoNome}
        />
      )}
      {editRegraModal.isOpen && editRegraModal.item && (
        segmentoNome === 'fundo' ? (
          <EditRegraModalAtivos
            isOpen={editRegraModal.isOpen}
            onRequestClose={editRegraModal.close}
            rowData={editRegraModal.item}
            segmentoNome={segmentoNome}
          />
        ) : (
          <EditRegraModalOutrosAtivos
            isOpen={editRegraModal.isOpen}
            onRequestClose={editRegraModal.close}
            rowData={editRegraModal.item}
          />
        )
      )}
    </>
  );
};

export default TableAtivos;
